import {strings} from '@app/common/strings';
import {monthMock} from '@app/components/widgets/placeholder/multiselect-placeholder';
import {MONTH_OBJECT} from '@app/screens/module-specific-utilities/module-specific-utilities.types';
import {approveExpenseStateActions} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import {
  fetchDailyExpenseApprovalsDataCreator,
  fetchMonthlyExpenseCreator,
} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/slice';
import {TableRow, TableCell, Checkbox, IconButton} from '@mui/material';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

export const util: any = {
  handleClick: null,
  isRowSelected: null,
  handleSetOpen: null,
};

const cellPadding = {
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingLeft: '8px',
  paddingRight: '4px',
};

export const SelectableCollapsibleRow = (props: any) => {
  const dispatch = useDispatch();
  const {row, collapseIconPadding} = props;
  const [open, setOpen] = useState(false);
  const [iconPadding, setIconPadding] = useState(collapseIconPadding);
  const adminExpenseSelectedRows =
    useSelector(
      approveExpenseStateSelector.getSelectedExpenseApprovalsData(),
    ) ?? [];

  const handleClick = (_event: any, rowParam: any) => {
    const {sapCode, expenseMonth, expenseYear, staffPositionId} = rowParam;
    const selectedIndex = adminExpenseSelectedRows?.indexOf(rowParam);
    let newSelected: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(adminExpenseSelectedRows, rowParam);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(adminExpenseSelectedRows?.slice(1));
    } else if (selectedIndex === adminExpenseSelectedRows?.length - 1) {
      newSelected = newSelected.concat(adminExpenseSelectedRows?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        adminExpenseSelectedRows?.slice(0, selectedIndex),
        adminExpenseSelectedRows?.slice(selectedIndex + 1),
      );
    }
    dispatch(
      approveExpenseStateActions.setSelectedExpenseApprovalsData(newSelected),
    );
    const selectedUser = [
      {
        sapCode,
        year: expenseYear,
        month: expenseMonth,
        staffPositionId,
      },
    ];

    if (_event?.target?.checked && newSelected?.length < 2) {
      dispatch(
        fetchDailyExpenseApprovalsDataCreator({
          multipleUsers: selectedUser,
          isFromExpenseTable: true,
        }),
      );
      dispatch(fetchMonthlyExpenseCreator(selectedUser));
    }
  };

  const isRowSelected = (rowParam: any) => {
    let isSelected = false;
    isSelected = adminExpenseSelectedRows?.indexOf(rowParam) !== -1;

    return isSelected;
  };

  const isItemSelected = isRowSelected(row);

  const handleSetOpen = () => {
    setIconPadding(open ? iconPadding - 2 : iconPadding + 2);
    setOpen(!open);
  };

  util.handleClick = handleClick;
  util.isRowSelected = isRowSelected;
  util.handleSetOpen = handleSetOpen;

  return (
    <>
      {row !== null && (
        <>
          <TableRow key={row?.expenseHistoryId}>
            <TableCell padding="checkbox">
              <Checkbox
                data-testid="selectableCheckbox"
                onClick={(event: any) => handleClick(event, row)}
                color="primary"
                checked={isItemSelected}
              />
            </TableCell>
            <TableCell>
              {row?.subordinates?.length > 0 ? (
                <IconButton
                  size="small"
                  onClick={handleSetOpen}
                  sx={{pl: collapseIconPadding}}>
                  {open && <b>-</b>}
                  {!open && <b>+</b>}
                </IconButton>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.isAiProcessed === true
                ? strings.yes
                : row?.isAiProcessed === false
                ? strings.no
                : '-'}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.taAiApprovedPercent != null
                ? `${row?.taAiApprovedPercent}%`
                : '-'}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.daAiApprovedPercent != null
                ? `${row?.daAiApprovedPercent}%`
                : '-'}
            </TableCell>
            <TableCell style={cellPadding}>{row?.sapCode}</TableCell>
            <TableCell style={cellPadding}>{row?.staffName}</TableCell>
            <TableCell style={cellPadding}>{row?.hqName}</TableCell>
            <TableCell style={cellPadding}>{row?.designationName}</TableCell>
            <TableCell style={cellPadding}>{row?.stateName}</TableCell>
            <TableCell style={cellPadding}>{row?.divisionName}</TableCell>
            <TableCell component="th" scope="row" style={cellPadding}>
              {`${
                (monthMock() || [])
                  ?.find(
                    (month: MONTH_OBJECT) => month?.key === row?.expenseMonth,
                  )
                  ?.value?.substring(0, 3) ?? row?.expenseMonth
              },${row?.expenseYear}`}
            </TableCell>
            <TableCell style={cellPadding}>{row?.adminComment}</TableCell>
            <TableCell style={cellPadding}>
              {row?.adminApprovedTaAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.adminApprovedDaAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.adminApprovedMiscAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.dacustomTotalAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.tacustomTotalAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.miscCustomTotalAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.managerApprovedTaAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.managerApprovedDaAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.managerApprovedMiscAmount}
            </TableCell>
            <TableCell style={cellPadding}>{row?.totalClaimedAmount}</TableCell>
            <TableCell style={cellPadding}>
              {row?.managerApprovedTotalAmount}
            </TableCell>
            <TableCell style={cellPadding}>
              {row?.adminApprovedTotalAmount}
            </TableCell>
          </TableRow>
          {row?.subordinates &&
            row?.subordinates?.length > 0 &&
            open &&
            row?.subordinates !== null &&
            row?.subordinates?.map((subrows: any) => (
              <SelectableCollapsibleRow
                key={subrows?.expenseHistoryId}
                row={subrows}
                selectAll={props?.selectAll}
                collapseIconPadding={iconPadding}
              />
            ))}
        </>
      )}
    </>
  );
};
